// importantcommentview.js

import CommentView from '@ckeditor/ckeditor5-comments/src/comments/ui/view/commentview';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';
import { updateAllReactionInfo } from '../lib/ckeditorLib';

import './myCommentview.css';

// デフォルトのビューをベースに、新しいコメントビュークラスを作成します。
export default class MyCommentView extends CommentView {
  // メソッドを上書きして、カスタムテンプレートを提供する。
  constructor(...args) {
    super(...args);

    // Bind `isImportant` value to comment model custom attributes.
    this.bind('isImportant').to(this._model, 'attributes', (attributes) => !!attributes.isImportant);
  }

  getTemplate() {
    // ここにテンプレートの定義を記入する。
    const templateDefinition = super.getTemplate();
    // console.log('templateDefinition:', templateDefinition)
    // If `isImportant` is `true`, add the `ck-comment--important` class to the template.
    templateDefinition.children[0].attributes.class.push(this.bindTemplate.if('isImportant', 'ck-comment--important'));

    // コメントボタンの横にボタンを追加する
    templateDefinition.children[0].children[1].children[0].children.push(this._createDecisionButtonView());
    templateDefinition.children[0].children[1].children[0].children.push(this._createFileClipButtonView());

    // templateDefinition.children[0].children[1].children[1].children.push(
    //   this._createDecisionButtonView()
    // );
    // templateDefinition.children[0].children[1].children[1].children.push(
    //   this._createFileClipButtonView()
    // );

    // // templateDefinition.children[0].children[1].children[1].children.unshift(
    // templateDefinition.children[0].children[1].children.unshift(
    // // templateDefinition.children[0].children[1].children.unshift(
    //     this._createFileClipButtonView()
    // );
    // // templateDefinition.children[0].children[1].children[1].children.unshift(
    // templateDefinition.children[0].children[1].children.unshift(
    // // templateDefinition.children[0].children[1].children.unshift(
    //     this._createDecisionButtonView()
    // );

    return templateDefinition;
  }

  // -------------------------------------------
  // ファイルアップロードボタン
  // -------------------------------------------
  _createFileClipButtonView() {
    // Create a new button view.
    const button = new ButtonView(this.locale);

    // Create an icon for the button view.
    const clipIcon =
      '<svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="2643.000000pt" height="2751.000000pt" viewBox="0 0 2643.000000 2751.000000" preserveAspectRatio="xMidYMid meet"><g transform="translate(0.000000,2751.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none"><path d="M19675 27499 c-943 -66 -1812 -361 -2523 -856 -318 -222 119 210-7887 -7794 l-7500 -7499 522 -522 523 -523 7467 7466 c4902 4900 7499 7490 7558 7536 316 246 611 405 980 529 848 286 1849 268 2825 -48 985 -320 1761-854 2321 -1598 328 -436 608 -1000 779 -1567 303 -1012 290 -2046 -37 -2878-122 -311 -270 -570 -471 -825 -88 -112 -16640 -16674 -16792 -16802 -137-116 -312 -228 -495 -318 -453 -223 -947 -322 -1530 -307 -461 12 -867 84-1325 237 -708 235 -1325 621 -1753 1095 -447 496 -722 1081 -829 1765 -19 127 -22 184 -23 460 0 251 4 340 18 435 94 639 318 1166 705 1655 90 113 13402 13435 13557 13566 364 309 824 519 1326 605 158 27 530 37 706 20 1128-115 2067 -907 2369 -2000 203 -735 86 -1535 -319 -2186 -157 -252 189 99-6056 -6148 l-5836 -5837 520 -520 c286 -286 524 -520 530 -520 17 0 11626 11618 11722 11731 548 646 870 1372 985 2224 20 150 22 212 23 525 0 380 -8 479 -61 770 -85 460 -250 916 -482 1325 -79 140 -267 416 -378 555 -138 173-471 506 -644 644 -145 115 -417 300 -567 385 -477 269 -1024 448 -1583 516-181 23 -638 31 -823 16 -974 -81 -1847 -464 -2557 -1123 -69 -64 -3109 -3101-6756 -6750 -4336 -4338 -6667 -6676 -6736 -6758 -500 -595 -828 -1234 -1007-1961 -95 -385 -130 -657 -138 -1064 -9 -472 32 -846 142 -1280 294 -1161 989-2140 2015 -2837 1345 -914 3086 -1255 4555 -893 726 179 1333 507 1866 1008 253 237 16602 16598 16691 16702 185 217 386 502 513 725 343 603 552 1292 627 2070 20 210 17 880 -5 1100 -56 554 -163 1043 -338 1555 -409 1197 -1113 2198 -2034 2891 -1004 756 -2252 1215 -3545 1304 -169 11 -642 11 -815 -1z"/></g></svg>';

    // Use the localization service.
    // The feature will be translatable.
    const t = this.locale.t;

    // Set the label and the icon for the button.
    button.set({
      icon: clipIcon,
      isToggleable: true,
      tooltip: t('file upload'),
      withText: true,
    });

    // Add a class to the button to style it.
    button.extendTemplate({
      attributes: {
        class: 'ck-button-important',
      },
    });

    // The button should be enabled if the comment model is not in read-only mode.
    // The same setting is used for other comment buttons.
    button.bind('isEnabled').to(this._model, 'isReadOnly', (value) => !value);

    // The button should be hidden if the comment is not editable
    // (this is true when the current user is not the comment author).
    // The same setting is used for other comment buttons.
    button.bind('isVisible').to(this._model, 'isEditable');

    // When the button is clicked, change the comment state in the comment model.
    // The `attributes.isImportant` value will be available together with other comment data.
    button.on('execute', () => {
      // 現在のスレッドIDを外部に知らせる為にセットする
      document.getElementById('currentThreadId').value = this._model.threadId;
      document.getElementById('currentCommentId').value = this._model.id;

      // // <p><a href='' target='_blank'>filename</a></p>
      // let fragment = document.createDocumentFragment();
      // let p = document.createElement('p');
      // let a = document.createElement('a');
      // a.setAttribute("href", "http://www.google.co.jp/");
      // a.setAttribute("target", "_blank");
      // a.textContent = 'new File'

      // fragment.append(p);
      // p.append(a);
      // element2.appendChild(fragment)

      // fragment.append(p);
      // p.append(a);
      // element2.appendChild(fragment)

      // 欄外に用意した<input type="file">タグを開く
      document.getElementById('image-select').click();
    });

    return button;
  }

  // -------------------------------------------
  // 完了ボタン
  // -------------------------------------------
  _createDecisionButtonView() {
    // Create a new button view.
    const button = new ButtonView(this.locale);

    // Create an icon for the button view.
    const decisionIcon =
      '<svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="25.000000pt" height="24.000000pt" viewBox="0 0 25.000000 24.000000" preserveAspectRatio="xMidYMid meet"><g transform="translate(0.000000,24.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none"><path d="M95 208 c-40 -10 -65 -45 -65 -91 0 -95 132 -130 175 -46 22 41 18 73 -10 107 -28 33 -57 42 -100 30z m75 -66 c0 -5 -11 -19 -25 -32 -20 -19 -30 -22 -42 -14 -26 16 -30 39 -5 25 15 -8 23 -6 37 9 19 21 35 26 35 12z"/></g></svg>';

    // Use the localization service.
    // The feature will be translatable.
    const t = this.locale.t;

    // Set the label and the icon for the button.
    button.set({
      icon: decisionIcon,
      isToggleable: true,
      tooltip: t('decision'),
      withText: true,
      isEnabled: true,
    });

    // Add a class to the button to style it.
    button.extendTemplate({
      attributes: {
        class: 'ck-button-complete',
      },
    });

    // // The button should be enabled if the comment model is not in read-only mode.
    // // The same setting is used for other comment buttons.
    // button.bind("isEnabled").to(this._model, "isReadOnly", (value) => !value);

    // // The button should be hidden if the comment is not editable
    // // (this is true when the current user is not the comment author).
    // // The same setting is used for other comment buttons.
    // button.bind("isVisible").to(this._model, "isEditable");

    // When the button is clicked, change the comment state in the comment model.
    // The `attributes.isImportant` value will be available together with other comment data.
    button.on('execute', () => {
      // console.log("button.on ------------------------:")
      // console.log("button.on this._model:", this._model)
      // console.log("button.on this._model.isComplete:", this._model.isComplete)

      // querySelectorAllを使ってthread-idのiscompleteの値を取得する(_modelの値だとundefinedになるケースがある)
      // <div class="ck-thread ck-reset_all-excluded" data-thread-id="2-202391416311234" tabindex="-1" iscomplete="true">
      let divThread = document.querySelector('div[data-thread-id="' + this._model.threadId + '"]');

      // 現在のスレッドのみReadOnlyになる
      let isComplete = false;
      if (divThread.getAttribute('iscomplete') === 'true') isComplete = true;
      // console.log("button.on divThread.isComplete:", isComplete)

      // this._model.isReadOnly = !this._model.isReadOnly;
      this._model.isComplete = !isComplete;

      // 完了ボタンのみ有効にする
      button.set({ isEnabled: true });

      divThread.setAttribute('isComplete', this._model.isComplete);
      // let divThread = document.querySelectorAll('div[data-thread-id="' + thread.threadId + '"]');
      // console.log("divThread:", divThread)

      // ck-disabledがclass属性についているとボタンの表示/非表示がうまく動かないので消す
      // var elems = divThread.querySelectorAll(`.ck-disabled`);
      // // console.log("elems:", elems)
      // for (var i = 0; i < elems.length; i++) {
      //   // console.log("divThread before:",elems[i]);
      //   let attrValue = elems[i].getAttribute('class');
      //   // console.log("divThread attrValue:",attrValue);
      //   attrValue = attrValue.replace('ck-disabled', '');
      //   elems[i].setAttribute('class', attrValue);
      //   // console.log("divThread after:",elems[i]);
      // }

      // コメント・リアクションを更新
      updateAllReactionInfo();
    });
    return button;
  }
}
